export enum ProductApiUrlsEnum {
  GetProducts = '/api/product/GetProducts'
}
